import { render, staticRenderFns } from "./ReportSubCategoryBadge.vue?vue&type=template&id=5eeb64b3&scoped=true&"
import script from "./ReportSubCategoryBadge.vue?vue&type=script&lang=js&"
export * from "./ReportSubCategoryBadge.vue?vue&type=script&lang=js&"
import style0 from "./ReportSubCategoryBadge.vue?vue&type=style&index=0&id=5eeb64b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eeb64b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
